export function ViewShell({ children }: { children: JSX.Element }): JSX.Element {
  return <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-10">{children}</div>
}
